import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Card, CardBody, Alert, Button } from "reactstrap";
import { FileText, CheckCircle } from "react-feather";
import axios from "axios";
import Header from "../Header";
import RequestInvoiceModal from "./RequestInvoiceModal";

const SubscriptionPlans = () => {
  const history = useHistory();
  const [user, setUser] = useState(null);
  const [host, setHost] = useState("");
  const [invoiceModalOpen, setInvoiceModalOpen] = useState(false);
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [activePlanName, setActivePlanName] = useState("");
  const testHost = ["localhost", "127.0.0.1", "frontend.therdlink.com"];

  const checkSubscriptionStatus = () => {
    const rawUser = localStorage.getItem(process.env.REACT_APP_USERDATA);
    if (!rawUser) return;
    const userData = JSON.parse(rawUser);
    setUser(userData);

    const token = localStorage.getItem(process.env.REACT_APP_USERTOKEN);
    const baseUrl = process.env.REACT_APP_BASEURL;
    if (userData && (userData.role === "brand" || userData.user_type === "brand") && token) {
      axios
        .get(`${baseUrl}brand/subscription-invoices`, {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          if (res.data?.status && res.data?.is_subscribed) {
            setIsSubscribed(true);
            setActivePlanName(
              res.data.current_plan_name ||
                res.data.latest_paid_invoice?.plan_name ||
                "Active Plan"
            );
            userData.subscription_exp = false;
            userData.subscriptionexp = false;
            if (res.data.active_subscription_id) {
              userData.active_subscription_id = res.data.active_subscription_id;
            }
            localStorage.setItem(
              process.env.REACT_APP_USERDATA,
              JSON.stringify(userData)
            );
          }
        })
        .catch(() => {});
    }
  };

  useEffect(() => {
    setHost(window.location.hostname);
    checkSubscriptionStatus();

    const onWindowFocus = () => {
      checkSubscriptionStatus();
    };
    window.addEventListener("focus", onWindowFocus);
    return () => {
      window.removeEventListener("focus", onWindowFocus);
    };
  }, []);

  return (
    <>
      <Header />
      <Card className="mt-1 bg-light">
        <div className="font-large-2 font-weight-bold text-dark text-center mt-2">
          Plans & Pricing
        </div>
        <div className="font-medium-4 font-weight-bold text-primary text-center">
          Please select your desired subscription plan from the options below
        </div>

        {/* ─── Invoice Payment Option / Active Status Banner ─── */}
        <div className="d-flex justify-content-center px-2 mt-2">
          {isSubscribed ? (
            <Alert
              color="success"
              className="d-flex align-items-center justify-content-between flex-wrap p-1 w-100 shadow-sm"
              style={{ maxWidth: "980px" }}
            >
              <div className="d-flex align-items-center mb-50 mb-sm-0">
                <CheckCircle className="mr-1 text-success" size={24} />
                <div>
                  <strong className="text-dark">Subscription Active & Paid!</strong>{" "}
                  <span className="text-muted">
                    {activePlanName} is active. You can review plans here or return to your dashboard.
                  </span>
                </div>
              </div>
              <Button
                color="success"
                size="sm"
                className="ml-auto font-weight-bold"
                onClick={() => {
                  if (history) {
                    history.push("/dashboard/brands");
                  } else {
                    window.location.href = "/dashboard/brands";
                  }
                }}
              >
                Go to Dashboard →
              </Button>
            </Alert>
          ) : (
            <Alert
              color="primary"
              className="d-flex align-items-center justify-content-between flex-wrap p-1 w-100"
              style={{ maxWidth: "980px" }}
            >
              <div className="d-flex align-items-center mb-50 mb-sm-0">
                <FileText className="mr-1 text-primary" size={24} />
                <div>
                  <strong className="text-dark">Need to pay by invoice?</strong>{" "}
                  <span className="text-muted">
                    Corporate purchasing, Net 30 terms, PO, ACH, or Wire invoicing available.
                  </span>
                </div>
              </div>
              <Button
                color="primary"
                size="sm"
                className="ml-auto"
                onClick={() => setInvoiceModalOpen(true)}
              >
                Click here
              </Button>
            </Alert>
          )}
        </div>

        <CardBody>
          {testHost.includes(host) ? (
            <stripe-pricing-table
              pricing-table-id="prctbl_1RCngEIgylPJBQXhBGqGN5DA"
              publishable-key="pk_test_51J0RjVIgylPJBQXhwWjTXM7b0IvoTvhg3gbpsXOPS1sRbu7l98E8L925CCufAtL1dUpVklC5iz73qAVWzv4dzcn500Jws8KJaH"
              customer-email={
                user?.parent_email ? user?.parent_email : user?.email
              }
            ></stripe-pricing-table>
          ) : (
            <stripe-pricing-table
              pricing-table-id="prctbl_1TP5PXJaYauMi320jE7369vW"
              publishable-key="pk_live_AszmJDHaci0zOdI1nJ9aA7U4"
              customer-email={
                user?.parent_email ? user?.parent_email : user?.email
              }
            ></stripe-pricing-table>
          )}
        </CardBody>
      </Card>

      <RequestInvoiceModal
        isOpen={invoiceModalOpen}
        toggle={() => {
          setInvoiceModalOpen(!invoiceModalOpen);
          checkSubscriptionStatus();
        }}
        user={user}
        onSubscriptionSuccess={checkSubscriptionStatus}
      />
    </>
  );
};

export default SubscriptionPlans;
